// Copyright (c) 2024. All Rights Reserved.
// Proprietary software of OPX Technology
// author: ckhoo

/**
    Handle Wiki edit from virtual host (e.g. https://help.oro247.com instead of https://opx.oro247.com
 **/
if (frappe.boot.sitename && frappe.boot.sitename != $(location).attr('hostname')) {
    // remove wiki direct edits
    $("#wikiOptionsButton").remove();
    $(".sidebar-edit-mode-btn").remove();
}

/**
    Handle webhosting
 **/
if (frappe.boot.ov_webhosting_enabled && frappe.boot.sitename == $(location).attr('hostname')) {
    var pathname = $(location).attr('pathname').toLowerCase();
    var firstSegment = pathname.split('/')[1];
    if (firstSegment == "login") {
        // force the navbar to be OV's
        $("nav.navbar").replaceWith(`<nav class="navbar navbar-light navbar-expand-lg">
<div class="container">
<a class="navbar-brand" href="/"><img src="https://orovault-pub.s3.ap-southeast-1.amazonaws.com/oro247_assets/oro247-logo.png"></a>
</div>
</nav>`);

        // force the footer to be OV's
        $("footer.web-footer").replaceWith(`<footer class="ov-web-footer">
	<div class="container" style="font-size: small; text-align: center;">
    &copy; ` + frappe.boot.ov_current_year + ` All Rights Reserved | <a href="https://www.oro247.com/terms-of-service/" target="_blank">Terms</a> &amp; <a href="https://www.oro247.com/privacy-policy/" target="_blank">Privacy</a>
    <br>
    OPX Technology Pte Ltd (UEN: 202137569H)
	</div>
</footer>`);
    }
}
